

<h2>
  Frequently Asked Questions
</h2>

<h3>
  How does EvalUGrade work? I don't know that I trust a complicated attempt at Artificial Intelligence (AI) such as ChatGPT to evaluate
  work.
</h3>

<p>
  Neither would we! Our patent pending method of grading is mostly heuristic,
  relying on the minimum necessary amount of AI interwoven into a much larger <em>engineered</em> solution.
</p>

<h3>
  What sort of work are you capable of evaluating?
</h3>
<p>
  We can evaluate Math up to Calculus II, including algebra and trigonometry. Additionally we can do baby physics.
  We'll be expanding further as quickly as we can.
</p>


<!--<h3>-->
<!--  What sort of uploads are permissible? -->
<!--</h3>-->

<!--<p>-->
<!--  Your students may use any paper type; graph or lined. We ask only that they both use a pen or pencil that is darker than-->
<!--  the page and make an effort to align the paper in the image.-->
<!--</p>-->
<!--
<h3>
  What are your accessibility options?
</h3>

<p>
  We will soon offer spoken input and output. Additionally we hope to soon have a font type that curbs dyslexia.
</p>
-->

<h3>Why would anyone use your specialized service over something general like ChatGPT?</h3>
<!--
-->
<p>
  Despite it's promises Generalized PreTraining (GPT) does not confer infinite benefits and functions well to a pretty specific set
  of problems. As far as the domain containing the only AI part of our application, GPT is not performant. As an example
  of ChatGPT in the non-AI component of our application, it may properly perform two digit multiplication but as
  the digits which one deals with expand it is no
  longer correct. One must remember that it finds answers in a manner akin to how a librarian might find a book, however
  the book is a fuzzy remembrance etched in ink that depends on a set of interdependent inkblots.
</p>
<h3>
How Accurate is EDUP.AI?
</h3>

<p>
We will tell you if your answer confuses us. We require clarification if
</p>


<p>
  There is a symbolic engine that backs EDUP.AI and while we occasionally have bugs they are not so suitable as to
  only effect our correctness. You'll know when we're broken.
</p>

